import React from "react";
import Modal from "react-modal";
import classNames from "classnames";
import PropTypes from "prop-types";
import CloseButton from "../CloseButton";
import { motion } from "framer-motion";
import useWindowSize from "../../../hooks/useWindowSize";

const Dialog = (props) => {
  const currentSize = useWindowSize();

  const {
    children,
    className,
    closable,
    title,
    width,
    height,
    style,
    isOpen,
    onClose,
    bodyOpenClassName,
    portalClassName,
    overlayClassName,
    contentClassName,
    closeTimeoutMS,
    ...rest
  } = props;

  const onCloseClick = (e) => {
    onClose(e);
  };

  const renderCloseButton = (
    <CloseButton
      onClick={onCloseClick}
      className="right-3 top-3 border border-[#000000] bg-primary text-lightwhite rounded-full p-1"
      absolute
    />
  );

  const contentStyle = {
    content: {
      inset: "",
      padding: "16px", // Add padding for small screens
    },
    ...style,
  };

  // Dynamically set width and height for small screens
  if (width !== undefined) {
    contentStyle.content.width = width;

    if (currentSize.width <= 420) {
      // Handle small screens (320px - 420px)
      contentStyle.content.width = "90%";
      contentStyle.content.maxWidth = "90%";
    } else if (currentSize.width <= 768) {
      // Handle medium screens (e.g., tablets)
      contentStyle.content.width = "80%";
    }
  }

  if (height !== undefined) {
    contentStyle.content.height = height;

    if (currentSize.width <= 420) {
      contentStyle.content.height = "auto"; // Allow content to scroll
    }
  }

  const defaultDialogContentClass = "dialog-content";

  const dialogClass = classNames(defaultDialogContentClass, contentClassName);

  return (
    <Modal
      className={{
        base: classNames("dialog", className),
        afterOpen: "dialog-after-open",
        beforeClose: "dialog-before-close",
      }}
      overlayClassName={{
        base: classNames("dialog-overlay", overlayClassName),
        afterOpen: "dialog-overlay-after-open",
        beforeClose: "dialog-overlay-before-close",
      }}
      portalClassName={classNames("dialog-portal", portalClassName)}
      bodyOpenClassName={classNames("dialog-open", bodyOpenClassName)}
      ariaHideApp={false}
      isOpen={isOpen}
      style={{ ...contentStyle }}
      closeTimeoutMS={closeTimeoutMS}
      {...rest}
    >
      <motion.div
        className={dialogClass}
        initial={{ transform: "scale(0.9)" }}
        animate={{
          transform: isOpen ? "scale(1)" : "scale(0.9)",
        }}
      >
        {closable && renderCloseButton}
        {title && (
          <div className="dialog-title bg-[#F6FAFF] text-[#000000] text-base font-semibold text-center rounded-t-lg min-h-[50px] flex items-center justify-center">
            {title}
          </div>
        )}
        {children}
      </motion.div>
    </Modal>
  );
};

Dialog.propTypes = {
  closable: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  overlayClassName: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func,
  portalClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  closeTimeoutMS: PropTypes.number,
  bodyOpenClassName: PropTypes.string,
};

Dialog.defaultProps = {
  closable: true,
  width: 520,
  closeTimeoutMS: 150,
};

export default Dialog;
